import React from 'react';
import { useToast } from '@/hooks';
import { ToastContext } from '@/hooks';
import { Toast } from '@/components/ui';

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { toast, showToast, clearToast } = useToast();

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={clearToast}
      />
    </ToastContext.Provider>
  );
}
